"use strict";

var PureRenderMixin = React.addons.PureRenderMixin;
var _ = require("underscore");
var BooleanInput = require("app/shared/components/BooleanInput/boolean-input");
var DatePicker =  require("app/shared/components/DatePicker/date-picker");
var TextArea = require("app/shared/components/TextArea/text-area");
var Button = require("app/shared/components/Button/button");
var Popbox = require("app/shared/components/Popover/popbox");
var lockScroll = require("app/util/browser/scroll");

var DESCRIPTION_LENGTH_LIMIT = 255;

var LossReasonsList = React.createClass({
  componentDidMount: function() {
    this._lossReasonsList.addEventListener("wheel", this.handleScroll);
  },
  componentWillUnmount: function() {
    this._lossReasonsList.removeEventListener("wheel", this.handleScroll);
  },
  handleScroll: function(e) {
    return lockScroll(this._lossReasonsList, e);
  },
  getLossReasons: function() {
    var lossReasons = _.map(this.props.lossReasons, function(lossReason) {
      var itemProps = {
        id: lossReason.id,
        item: lossReason,
        name: lossReason.name,
        onClick: this.props.onSelectLossReason,
        selectedId: this.props.selectedLossReasonId
      };

      return <LossReasonsListItem key={lossReason.id} {...itemProps}/>;
    }.bind(this));

    return lossReasons;
  },
  render: function() {
    return (
      <div className="h-145 ovx-hidden ovy-auto dealLossReasonList fs-14"
        ref={(lossReasonsList) => this._lossReasonsList = lossReasonsList} >
        <ul>
          {this.getLossReasons()}
        </ul>
      </div>
    );
  }
});

const LossReasonsListItem = (props) => {
  var handleSelectLossReason = function() {
    props.onClick(props.item);
  };
  return (
    <li key={props.key}
      className="selector-item d-f jc-sb"
      onClick={handleSelectLossReason}>
      {props.name}
      <div className="ml-5">
        <BooleanInput
          type="radioButton"
          checked={props.id === props.selectedId}
          border="thick"
          placement="right"
          color="grey">
        </BooleanInput>
      </div>
    </li>
  );
};

const DealLostConfig = (props) => (
  <div className="bootstrap-agendor bg-white u-boxShadow-light br-4 b-light ovf-h">
    <div className="w-230 d-tc p-5 p-r dealLossReason-datePicker">
      <span className="ta-c d-b fs-16 mb-10 fw-bold c-darkGray">Quando o negócio foi perdido?</span>
      <DatePicker
        selectedDate={props.selectedDate}
        onSelectDate={props.onDateChange} />
    </div>
    <div className="w-230 d-tc p-5 p-r bg-lightGreyBlue">
      <span className="ta-c d-b fs-16 mb-10 fw-bold c-darkGray">Qual foi o motivo da perda?</span>
      <LossReasonsList
        lossReasons={props.lossReasons}
        selectedLossReasonId={props.selectedLossReasonId}
        onSelectLossReason={props.onSelectLossReason} />
      <div className="dealLossReason w-100"></div>
      <TextArea
        width="220"
        height="68"
        maxHeight="68"
        value={props.lossReasonDescription}
        onChange={props.onDescriptionChange}
        placeholder="Comentário (opcional)"
        className="ovf-h pr-25"
        maxLength={DESCRIPTION_LENGTH_LIMIT}
        isDisabled={props.selectedLossReasonId ? false : true}
        showMaxLengthCounter={true} />
      <Button className="w-100 fs-12 fw-600 mt-10" type="danger" onClick={props.onSave}>DEFINIR</Button>
    </div>
  </div>
);

const LossReasonsLoading = () => (
  <div className="bootstrap-agendor bg-white u-boxShadow-light br-4 b-light ovf-h">
    <div className="w-230 f-l d-ib p-5 p-r">
      <div className="dealLossReason-title--loading"></div>
      <div className="dealLossReason-datePicker-monthSelector--loading"></div>
      <ul className="m-5 d-b">
        <li className="dealLossReason-datePicker-weekItem--loading"></li>
        <li className="dealLossReason-datePicker-weekItem--loading"></li>
        <li className="dealLossReason-datePicker-weekItem--loading"></li>
        <li className="dealLossReason-datePicker-weekItem--loading"></li>
        <li className="dealLossReason-datePicker-weekItem--loading"></li>
        <li className="dealLossReason-datePicker-weekItem--loading"></li>
        <li className="dealLossReason-datePicker-weekItem--loading"></li>
      </ul>
      <ul className="m-5">
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
        <li className="dealLossReason-datePicker-dayItem--loading"></li>
      </ul>
    </div>
    <div className="w-230 d-ib p-5 p-r bg-lightGreyBlue">
      <div className="dealLossReason-title--loading"></div>
      <div className="h-225 ml-10 mr-10">
        <div className="dealLossReason-listItem--loading"></div>
        <div className="dealLossReason-listItem--loading"></div>
        <div className="dealLossReason-listItem--loading"></div>
      </div>
      <div className="dealLossReason-btn-loading"></div>
    </div>
  </div>
);

var DealLostPopbox = React.createClass({
  propTypes: {
    lossReasons: React.PropTypes.array,
    selectedLossReasonId: React.PropTypes.number,
    onSelectLossReason: React.PropTypes.func.isRequired,
    onSave: React.PropTypes.func.isRequired,
    selectedDate: React.PropTypes.string.isRequired,
    onDateChange: React.PropTypes.func.isRequired,
    lossReasonDescription: React.PropTypes.string,
    onDescriptionChange: React.PropTypes.func.isRequired,
    anchor: React.PropTypes.object,
    onClose: React.PropTypes.func,
    isVisible: React.PropTypes.bool
  },
  getDefaultProps: function() {
    return {
      isVisible: true
    };
  },
  render: function() {
    return (
      <Popbox
        isVisible={this.props.isVisible}
        anchor={this.props.anchor}
        onClose={this.props.onClose}>
        {
          this.props.lossReasons
          ? <DealLostConfig {...this.props} />
          : <LossReasonsLoading />
        }
      </Popbox>
    );
  }
});

module.exports = DealLostPopbox;



// WEBPACK FOOTER //
// ./app/shared/components/DealLostPopbox/deal-lost-popbox.jsx